<template>
  <div class="p-d-flex p-flex-column p-ai-center">
    <div class="p-mt-6 p-mb-5 text-title">Choisissez votre formule</div>

    <div class="p-grid">
      <div class="p-col-12 p-md-5 p-md-offset-1">
        <Card class="card-descaling" @click="selectTypeOfProblem(1)">
          <template #title>Formule curative<br />95 €</template>
          <template #content>
            <div class="flexElements">
              <div class="cardSubtitle">
                Pour tout véhicule / tout moteur<br />
                1h à 1h30 d’intervention
              </div>
              <div class="cardText">
                <ul>
                  <li>Voyant moteur allumé</li>
                  <li>Perte de puissance</li>
                  <li>Gaz / Fumées</li>
                  <li>Facilite le passage au contrôle technique</li>
                </ul>
              </div>
            </div>
            <RadioButton
              id="curation"
              name="typeOfProblem"
              value="1"
              v-model="typeOfProblem"
              class="p-my-3 p-my-sm-3 radio-button"
            />
          </template>
        </Card>
      </div>
      <div class="p-col-12 p-md-5">
        <Card class="card-descaling" @click="selectTypeOfProblem(2)">
          <template #title>Formule préventive<br />65 €</template>
          <template #content>
            <div class="flexElements">
              <div class="cardSubtitle">
                Pour tout véhicule / tout moteur<br />
                30 min à 1h d’intervention
              </div>
              <div class="cardText">
                <ul>
                  <li>1 fois par an ou tous les 15000 km</li>
                </ul>
              </div>
            </div>
            <RadioButton
              id="prevention"
              name="typeOfProblem"
              value="2"
              v-model="typeOfProblem"
              class="p-my-3 p-my-sm-3 radio-button last-radio-button"
            />
          </template>
        </Card>
      </div>
    </div>

    <small
      v-if="
        intervention.typeOfProblem.$invalid && intervention.typeOfProblem.$dirty
      "
      class="p-error"
    >
      Veuillez selectionner une formule
    </small>

    <div class="p-d-inline-flex p-jc-center p-my-6" style="width: 60%">
      <div class="p-mt-sm-3 p-mr-5">
        <Button class="button-navigate button-back" @click="onPrevious">Précédent</Button>
      </div>
      <div class="p-mt-sm-3">
        <Button class="button-navigate" @click="onNext">Suivant</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useMenuStore } from "../stores/menu";
import { useAppointmentStore } from "../stores/appointment";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default {
  name: "StepDescaling",

  setup(props, { emit }) {
    const menuStore = useMenuStore();
    const appointmentStore = useAppointmentStore();
    const typeOfProblem = ref(null);

    const rules = {
      typeOfProblem: { required },
    };

    const intervention = useVuelidate(rules, {
      typeOfProblem,
    });

    const getNextUrl = () => {
      let nextUrl = null;
      switch (typeOfProblem.value) {
        case "1":
          nextUrl = "/mon-vehicule";
          appointmentStore.appointment.descaling_option = 'curation';
          break;
        case "2":
          nextUrl = "/mon-vehicule";
          appointmentStore.appointment.descaling_option = 'prevention';
          break;
      }
      return nextUrl;
    };

    const onNext = () => {
      intervention.value.$touch();
      if (!intervention.value.$error) {
        const nextUrl = getNextUrl();
        const target = menuStore.getMenuItemWithUrl(nextUrl);
        target.parent = menuStore.currentMenuItem.to;

        let dataLayerToPush = {
          'event' : 'click',
          'pageName' : '/prise-de-rendez-vous/#/decalaminage',
          'eventCategory' : 'rdv',
          'eventAction' : 'next',
          'eventName' : nextUrl,
        };
        if (appointmentStore.appointment.descaling_option) dataLayerToPush.descaling_option = appointmentStore.appointment.descaling_option;
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerToPush);

        emit("nextPage", target);
      }
    };

    const onPrevious = () => {
      appointmentStore.appointment.descaling_option = null
      emit("prevPage", menuStore.currentMenuItem);
    };

    const selectTypeOfProblem = (typeOfProblemId) => {
      typeOfProblem.value = `${typeOfProblemId}`
    }

    return {
      onNext,
      intervention,
      typeOfProblem,
      onPrevious,
      selectTypeOfProblem,
    };
  },
};
</script>

<style>
.card-descaling {
  width: 100% !important;
  background-color: #24a285 !important;
  height: 100% !important;
  border: 1px dashed #24a285;
  box-shadow: none !important;
  border-radius: 10px !important;
}
.card-descaling .p-card-body {
  padding: 0px !important;
}
.card-descaling .cardSubtitle {
  color: #24a285 !important;
  text-align: center !important;
  margin-bottom: 10px !important;
}
.card-descaling .p-card-content {
  background-color: #f6f7f8 !important;
  color: black !important;
  padding-top: 15px !important;
  font-size: 1.5em !important;
  line-height: 1.3em !important;
  text-align: center !important;
  height: 343px !important;
  border-radius: 0px 0px 10px 10px !important;
}
.card-descaling .p-card-title {
  font-size: 1.5em !important;
  line-height: 1.2em !important;
  color: white !important;
  text-align: center !important;
  padding-top: 10px;
}
.card-descaling .p-card-content .cardText {
  text-align: left !important;
  padding: 0px 10px !important;
}
.last-radio-button {
  margin-top: 118px !important;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .card-descaling .p-card-content {
    font-size: 1.1em !important;
    line-height: 1.1em !important;
    height: auto !important;
  }
  .card-descaling .p-card-title {
    font-size: 1.1em !important;
    line-height: 1.1em !important;
  }
  .last-radio-button {
  margin-top: auto !important;
}
}
</style>
